import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  container: {
    height: '100%',
    width: '100%',
    padding: theme.spacing(2),
  },
  dividerContainer: {
    padding: theme.spacing(1, 0, 3, 0),
  },
  divider: {
    backgroundColor: 'black',
  },
}));
